"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _filtersLarge = _interopRequireDefault(require("./filters-large"));
var _filtersSmall = _interopRequireDefault(require("./filters-small"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const formatCountDisplay = count => count === 1 ? "".concat(count, " item") : "".concat(count, " items");
const Wrapper = _ref => {
  let {
    childrenFunc,
    count,
    idPrefix,
    heading,
    onClick
  } = _ref;
  const [expanded, expand] = (0, _react.useState)(false);
  const formattedCountDisplay = typeof count === 'number' ? formatCountDisplay(count) : undefined;
  const clickHandle = () => {
    expand(!expanded);
    if (onClick) {
      onClick(expanded);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_filtersLarge.default, {
    countDisplay: formattedCountDisplay,
    idPrefix: idPrefix
  }, childrenFunc({
    id: 'large'
  })), /*#__PURE__*/_react.default.createElement(_filtersSmall.default, {
    countDisplay: formattedCountDisplay,
    idPrefix: idPrefix,
    heading: heading,
    onClick: clickHandle
  }, childrenFunc({
    id: 'small'
  })));
};
var _default = exports.default = Wrapper;